import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ProcessTrackingEinvoiceContainer } from '../../../../../../models/aggregates/erp/index';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Pagination } from '../../shared/pagination.model';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared/api-visa.model';
import { EinvoiceB2BSummaryDto } from '../../../data-transfer-objects';
import { BatchPaymentStatusUpdateRequestDto } from '../../../data-transfer-objects/pmtStmt/batch-payment-status-update-dto.model';

@Injectable({
    providedIn: 'root'
})
export class ProcessTrackingEinvoiceService extends BaseApiTemplateService<ProcessTrackingEinvoiceContainer> {
    
    private endpoint_path_without_ep;

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'process-tracking-einvoices/' + Core2Config.BACKOFFICE_EP_SUFFIX;

    constructor(http: HttpClient) {
        super();
        this.httpClient = http;
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'process-tracking-einvoices/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'process-tracking-einvoices/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path_without_ep = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'process-tracking-einvoices/';
    }

    public getByCriteriaEinvoiceAndB2BSummary (
      pagination: Pagination,
      visa: ApiVisa,
    ): Observable<PagingResponseModel<EinvoiceB2BSummaryDto>> {
      if (this.endpoint_path_without_ep && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep;
      }
      const UrlByCriteria =
        this.apiUrl + 'einvoice-b2b-summary/' + BaseApiTemplateService.BACKOFFICE_EP + '/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<EinvoiceB2BSummaryDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }

    public getByCriteriaEinvoiceAndB2BSummaryLoginConsolidatedArapEp (
      pagination: Pagination,
      visa: ApiVisa,
    ): Observable<PagingResponseModel<EinvoiceB2BSummaryDto>> {
      if (this.endpoint_path_without_ep && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep;
      }
      const UrlByCriteria =
        this.apiUrl + 'einvoice-b2b-summary/' + 'login-consolidated-arap-ep/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<EinvoiceB2BSummaryDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }

    public getByCriteriaLoginConsolidatedArapEp (
      pagination: Pagination,
      visa: ApiVisa,
    ): Observable<PagingResponseModel<ProcessTrackingEinvoiceContainer>> {
      if (this.endpoint_path_without_ep && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep;
      }
      const UrlByCriteria =
        this.apiUrl + 'login-consolidated-arap-ep/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<ProcessTrackingEinvoiceContainer>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }

    /** Get branch by guid */
    public getByGuidLoginConsolidatedArapEp(
      guid: string,
      visa: ApiVisa
    ): Observable<BasicApiResponseModel<ProcessTrackingEinvoiceContainer>> {
      if (this.endpoint_path_without_ep && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep + 'login-consolidated-arap-ep';
      }
      return this.httpClient.get<BasicApiResponseModel<ProcessTrackingEinvoiceContainer>>(
        this.apiUrl + '/' + guid,
        this.getHttpHeader(visa)
      );
    }

    public putLoginConsolidatedArapEp(dtoObject: ProcessTrackingEinvoiceContainer, visa: ApiVisa): Observable<PagingResponseModel<ProcessTrackingEinvoiceContainer>> {
      if (this.endpoint_path_without_ep && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep + 'login-consolidated-arap-ep';
      }
      return this.httpClient.put<PagingResponseModel<ProcessTrackingEinvoiceContainer>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

    public updateBatchPaymentStatus(dtoObject: BatchPaymentStatusUpdateRequestDto, apiVisa: ApiVisa):Observable<ApiResponseModel<ProcessTrackingEinvoiceContainer>> {
      if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
      }
      return this.httpClient.put<ApiResponseModel<ProcessTrackingEinvoiceContainer>>(
        this.apiUrl + '/update-payment-status',
        dtoObject,
        this.getHttpHeader(apiVisa)
      );
    }
    
}
